export class SignalDataView {
  dataView: DataView;
  constructor(file: ArrayBuffer) {
    this.dataView = new DataView(file);
  }
  getInt24LE(offset: number) {
    const byte0 = this.dataView.getUint8(offset);
    const byte1 = this.dataView.getUint8(offset + 1);
    const byte2 = this.dataView.getUint8(offset + 2);

    const val = byte0 + byte1 * 2 ** 8 + byte2 * 2 ** 16;
    return val | ((val & (2 ** 23)) * 0x1fe);
  }
  getUint8(byteOffset: number) {
    return this.dataView.getUint8(byteOffset);
  }

  getInt16(byteOffset: number, littleEndian?: boolean) {
    return this.dataView.getInt16(byteOffset, littleEndian);
  }

  getUint32(byteOffset: number, littleEndian?: boolean) {
    return this.dataView.getUint32(byteOffset, littleEndian);
  }

  getFloat32(byteOffset: number, littleEndian?: boolean) {
    return this.dataView.getFloat32(byteOffset, littleEndian);
  }
}

